
define('modules/application/subheader',[
  "app",

  // Libs
  "backbone"

],

function(app, Backbone) {

  // Create a new module
  var Subheader   = {};

  // Subheader Model
  // ----------
  Subheader.Model = Backbone.Model.extend({
    initialize : function() {
      var that = this;

      $.ajax({
          url         : '/WizardService.svc/getUser',
          type        : 'post',
          contentType : "application/json",
          dataType    : "json",
          data        : JSON.stringify(
            { token : window.BticinoS4B.token }
          ),
          success : function(data) {
            _.extend(that.attributes, data);
            switch ('ITA') {
            case 'ITA':
              BticinoS4B.Instances.Models.ApplicationModel.set("catalogId", that.get("catalogs")[0].code);
              break;
            case 'FRA':
              BticinoS4B.Instances.Models.ApplicationModel.set("catalogId", that.get("catalogs")[1].code);
              break;
            }
          }
        });
    }
  });

  // Subheader Views
  // ----------
  Subheader.View  = Backbone.View.extend({
    id      :   "subheader",
    tagName :   "section",
    template:   "application/subheader",

    serialize: function() {
        return {
          app: app,
          options: this.options,
          model: this.model
        };
    },
    initialize: function() {
      this.model = new Subheader.Model();
      this.model.set('projectName', window.BticinoS4B.Instances.Models.ApplicationModel.get("projectName"));
      this.model.set('choosenLine', window.BticinoS4B.Instances.Models.ApplicationModel.get("choosenLine"));
      this.model.set('choosenColor', window.BticinoS4B.Instances.Models.ApplicationModel.get("choosenColor"));
      // window.BticinoS4B.eventAggregator.unbind("language:changed", this.render, this);
      window.BticinoS4B.eventAggregator.bind("language:changed", this.render, this);
    },
    afterRender: function() {
      var title = this.$el.find(".systemIconSubheader")[0];

      if (title)
        $(title).css("margin-left", ($(title).width()-15) / -2 + "px");
    }

  });

  // Required, return the module for AMD compliance
  return Subheader;

});
